/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Box, Text } from 'theme-ui'
import { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'

import ParnershipVideos from '/components/Korea/ParnershipVideos'
import useResponsive from '/hooks/useResponsive'
import tracking from '/lib/tracking'
import getTrackingInfo from '/utils/getTrackingInfo'

import styles from './styles'

const KoreaPartnershipComponent = ({ ...props }) => {
  const {
    messageTitle = '',
    description = '',
    videoTitle = '',
    videos = [],
  } = props
  const { sendCSMEvent } = tracking()
  const { isMobile } = useResponsive(props.isMobile)

  const [videoProgress, setVideoProgress] = useState(0)
  const [closeVideo, setCloseVideo] = useState(true)

  useEffect(() => {
    if (closeVideo) onPauseVideo(videoProgress)
  }, [closeVideo, videoProgress])

  const onPauseVideo = (progress) => {
    const oneQuarter = 0
    const half = 50
    const threeQuarter = 75
    const full = 100

    if (progress > oneQuarter && progress < half) onVideoTracking('oneQuarter')
    if (progress >= half && progress < threeQuarter) onVideoTracking('half')
    if (progress >= threeQuarter && progress < full)
      onVideoTracking('threeQuarter')
  }

  const onClickVideo = () => {
    sendCSMEvent(getTrackingInfo('koreaPartnershipVideoPlay'))
    setCloseVideo(false)
  }

  const onVideoTracking = (percentage) => {
    sendCSMEvent(getTrackingInfo('koreaPartnershipVideoPlay', percentage))
    setVideoProgress(0)
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.textContainer}>
        <Text
          as="h3"
          sx={{ ...styles.partnershipTitle, variant: `text.partnershipTitle` }}
        >
          {messageTitle}
        </Text>
        <ReactMarkdown
          children={description}
          sx={{
            ...styles.partnershipDescription,
            variant: `text.partnershipDescription`,
          }}
        />
      </Box>
      <ParnershipVideos
        videoTitle={videoTitle}
        onClickVideo={onClickVideo}
        videos={videos}
        isMobile={isMobile}
        setVideoProgress={setVideoProgress}
        onVideoEnded={() => onVideoTracking('full')}
        onVideoPause={() => setCloseVideo(true)}
      />
    </Box>
  )
}

export default KoreaPartnershipComponent
